import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material';
import { Iceutility } from '../../services/iceutility';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb/breadcrumb.service';
import { BreadcrumType } from '../../services/baseapp.service';

@Component({
  selector: 'icebreadcrumbs',
  templateUrl: './icebreadcrumbs.component.html',
  styleUrls: ['./icebreadcrumbs.component.scss']
})
export class IcebreadcrumbsComponent implements OnInit {

  // Input Members
  @Input() breadcrumb_data: any = {};
  @Output() toolbarMenuItemClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() toolbarMenuItemOpen: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('clickMenuTrigger1') clickMenuTrigger1: MatMenuTrigger;
  @ViewChild('clickMenuTrigger2') clickMenuTrigger2: MatMenuTrigger;
  @ViewChild('clickMenuTrigger3') clickMenuTrigger3: MatMenuTrigger;
  @ViewChild('clickMenuTrigger4') clickMenuTrigger4: MatMenuTrigger;
  @ViewChild('clickMenuTrigger5') clickMenuTrigger5: MatMenuTrigger;
  @ViewChild('clickMenuTrigger6') clickMenuTrigger6: MatMenuTrigger;

  lastToolbarItemClicked: any = null;
  subMenuItemsMap = {};

  constructor(private router: Router, private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {
  }

  getCrums(): any[] {
    let bCrums = this.breadcrumb_data;
    let ret: any[] = [];
    if (bCrums.FARM != null && bCrums.FARM.data != null) ret.push(bCrums.FARM);
    if (bCrums.YARD != null && bCrums.YARD.data != null) ret.push(bCrums.YARD);
    if (bCrums.TREE != null && bCrums.TREE.data != null) ret.push(bCrums.TREE);
    if (bCrums.BRANCH != null && bCrums.BRANCH.data != null) ret.push(bCrums.BRANCH);

    ret = ret.concat(bCrums.LEAVES);
    return ret;
  }

  isToolbar(): boolean {
    this.toolbarMenuItemClick.observers.length
    return this.breadcrumb_data.TOOLBARS != null && this.breadcrumb_data.TOOLBARS.length > 0 && this.toolbarMenuItemClick.observers.length != 0;
  }

  isVisible(): boolean {
    return this.breadcrumb_data != null && this.breadcrumb_data.HIDE == null || this.breadcrumb_data.HIDE == false;
  }

  getToolbars(): any[] {
    let bars = this.breadcrumb_data.TOOLBARS;
    return bars == null ? [] : bars;
  }

  getToolbarItems(toolbar: any): any[] {
    return toolbar == null || toolbar.items == null || toolbar.items.length == 0 ? [] : toolbar.items;
  }

  getToolbarItemDisplay(toolbarItem: any): string {
    if (toolbarItem == null || toolbarItem.display == null || toolbarItem.display.length == 0) return "";

    return toolbarItem.display;
  }

  getToolbarItemMenu(toolbarItem: any): string {
    if (toolbarItem == null || toolbarItem.menuitem == null || toolbarItem.menuitem.length == 0) return "appMenu1";

    return toolbarItem.menuitem;
  }

  getToolbarItemMenuItems(toolbar: any, menuitem: string): any[] {
    if (toolbar == null || menuitem == null || toolbar[menuitem] == null
      || toolbar[menuitem].menuItems == null || toolbar[menuitem].menuItems.length == 0) return [];

    return toolbar[menuitem].menuItems;
  }

  getToolbarSubMenuItems(menuItem: any): any[] {
    if (!Iceutility.isdefined(menuItem) || !Iceutility.isdefined(menuItem.subMenuItems)) return [];

    return menuItem.subMenuItems;
  }

  getToolbarItemStyle(toolbarItem: any): any {
    let style = {
      color: 'black'
    };

    if (toolbarItem && toolbarItem.properties != null) {
      if (toolbarItem.properties.color != null)
        style.color = toolbarItem.properties.color;
    }
    return style;
  }

  getToolbarItemClass(toolbarItem: any): any {
    if (toolbarItem == null || toolbarItem.properties == null || toolbarItem.properties.class == null)
      return '';

    return toolbarItem.properties.class;
  }

  getHistory(item) {
    let values = [];

    for (let i = 0; i < item.history.length; i++) {
      if (item.history[i].display === "") continue;
      values.push(item.history[i].display);
    }

    return values;
  }

  onToolbarItemClick(event, toolbar: any, item: any) {
    this.lastToolbarItemClicked = item;
    event.toolbar = toolbar;
    event.toolbarItem = this.lastToolbarItemClicked;
    this.toolbarMenuItemOpen.emit(event);
    switch (item.menuitem) {
      case "appMenu1": {
        this.clickMenuTrigger1.openMenu();
        break;
      }
      case "appMenu2": {
        this.clickMenuTrigger2.openMenu();
        break;
      }
      case "appMenu3": {
        this.clickMenuTrigger3.openMenu();
        break;
      }
      case "appMenu4": {
        this.clickMenuTrigger4.openMenu();
        break;
      }
      case "appMenu5": {
        this.clickMenuTrigger5.openMenu();
        break;
      }
      case "appMenu6": {
        this.clickMenuTrigger6.openMenu();
        break;
      }
    }
  }

  onToolbarLinkClick(event, toolbarMenuItem: any) {
    event.historyNode = toolbarMenuItem;
    event.selectedItem = toolbarMenuItem;

    setTimeout(_ => {
      this.toolbarMenuItemClick.emit(event);
    }, 200);
  }

  onToolbarMenuClick(event, toolbar: any, toolbarMenuItem: any, isHistory: boolean = false) {
    if (!isHistory) {
      event.toolbar = toolbar;
      event.toolbarItem = this.lastToolbarItemClicked;
      event.toolbarMenuItem = toolbarMenuItem;
      this.toolbarMenuItemClick.emit(event);
      this.lastToolbarItemClicked = null;
    } else {
      event.historyNode = toolbar;
      let selected = toolbar.history.find(h => h.display === toolbarMenuItem);
      event.selectedItem = Iceutility.isdefined(selected) ? selected : null;
      let breadcrumbs = this.breadcrumbService.getBreadcrumbs();
      let breadcrumbData = {};
      let breadcrumbType: BreadcrumType;

      // maintain the current breadcrumb data based on what level the history item was clicked
      if (breadcrumbs.BRANCH != null && breadcrumbs.BRANCH.history != null && breadcrumbs.BRANCH.history.length > 0) {
        let foundHistory = breadcrumbs.BRANCH.history.find(h => h.display === toolbarMenuItem);
        if (Iceutility.isdefined(foundHistory)) {
          breadcrumbData = foundHistory.data;
          breadcrumbType = BreadcrumType.btBranch;
        }
      }

      if (breadcrumbs.YARD != null && breadcrumbs.YARD.history != null && breadcrumbs.YARD.history.length > 0) {
        let foundHistory = breadcrumbs.YARD.history.find(h => h.display === toolbarMenuItem);
        if (Iceutility.isdefined(foundHistory)) {
          breadcrumbData = foundHistory.data;
          breadcrumbType = BreadcrumType.btYard;
        }
      }

      if (breadcrumbType == BreadcrumType.btBranch) {
          this.router.navigateByUrl(event.selectedItem.link);
      }

      // update breadcrumbs for YARD
      if (breadcrumbType == BreadcrumType.btYard) {
        this.breadcrumbService.updateBreadcrumb(BreadcrumType.btYard.toString(), selected);
      }
      this.breadcrumbService.updateBreadcrumbData(breadcrumbData, breadcrumbType);

      setTimeout(_ => {        
        this.toolbarMenuItemClick.emit(event);
      }, 200);
    }
  }

  getSubMenuItems(menuItem: string) {
    if (Iceutility.isStringUndefinedNullOrEmpty(menuItem)) return [];

    return this.subMenuItemsMap[menuItem];
  }

  hasSubMenu(toolbar: any, menuItemNumber: number, index: number) {
    let menuItemName = "appMenu" + menuItemNumber;
    let toolbarValue = toolbar[menuItemName];

    if (toolbar == null || menuItemName == null || toolbarValue == null ||
      !Iceutility.isdefined(toolbarValue.menuItems) ||
      !Iceutility.isdefined(toolbarValue.menuItems[index]) ||
      !Iceutility.isdefined(toolbarValue.menuItems[index].subMenuItems) ||
      toolbarValue.menuItems[index].subMenuItems.length == 0) return false;

    return toolbarValue.menuItems[index].subMenuItems.length > 0;
  }
}
